// extracted by mini-css-extract-plugin
export var statItem = "_l4-1";
export var statsRow = "_l4-0";